export default "__VITE_ASSET__CIkhcvhL__"